import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 所有权限通用路由表
// 如登录页、注册页和一些不用权限的公用页面
export const constantRouterMap = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: () => import('../views/Login') },
  { path: '/jump', component: () => import('../views/Jump') }
]

// 实例化vue的时候只挂载constantRouter
export default new Router({
  // 去除访问路径中的#
  // mode: 'history',
  // 页面刷新时滚动条回到顶部
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

// 异步挂载的路由
// 动态需要根据权限加载的路由表
export const asyncRouterMap = [
  {
    path: '/home',
    component: () => import('../views/Home'),
    children: [
      {
        name: '首页',
        icon: 'el-icon-house',
        path: 'house',
        component: () => import('../components/house/List'),
        aside: true
      },
      {
        father: '用户管理',
        fatherIcon: 'el-icon-user',
        name: '广告主',
        path: 'adowner/list',
        component: () => import('../components/ad_owner/List'),
        meta: {id: 1300, power: [2]},
        aside: true
      },
      {
        path: 'adowner/edit',
        component: () => import('../components/ad_owner/Edit'),
        meta: {id: 1300, power: [8, 32]}
      },
      {
        path: 'adowner/record',
        component: () => import('../components/ad_owner/Record'),
        meta: {id: 1300, power: [128]}
      },
      {
        father: '用户管理',
        name: '广告主账号',
        path: 'aduser/list',
        component: () => import('../components/ad_user/List'),
        meta: {id: 100, power: [2]},
        aside: true
      },
      {
        path: 'aduser/edit',
        component: () => import('../components/ad_user/Edit'),
        meta: {id: 100, power: [8, 32]}
      },
      {
        father: '用户管理',
        name: '内部账号',
        path: 'mediaowner/list',
        component: () => import('../components/media_owner/List'),
        meta: {id: 200, power: [2]},
        aside: true
      },
      {
        path: 'mediaowner/edit',
        component: () => import('../components/media_owner/Edit'),
        meta: {id: 200, power: [8, 32]}
      },
      {
        father: '用户管理',
        name: '角色',
        path: 'role/list',
        component: () => import('../components/role/List'),
        meta: {id: 300, power: [2]},
        aside: true
      },
      {
        path: 'role/edit',
        component: () => import('../components/role/Edit'),
        meta: {id: 300, power: [8, 32]}
      },
      {
        name: '日志管理',
        icon: 'el-icon-notebook-1',
        path: 'log',
        component: () => import('../components/Log'),
        meta: {id: 400, power: [1]},
        aside: true
      },
      {
        name: '投放计划管理',
        icon: 'el-icon-date',
        path: 'plan/list',
        component: () => import('../components/plan/List'),
        meta: {id: 1100, power: [2]},
        aside: true
      },
      {
        path: 'plan/edit',
        component: () => import('../components/plan/Edit'),
        meta: {id: 1100, power: [8, 32]}
      },
      {
        name: '投放单元管理',
        icon: 'el-icon-place',
        path: 'unit/list',
        component: () => import('../components/unit/List'),
        meta: {id: 500, power: [2]},
        aside: true
      },
      {
        path: 'unit/edit',
        component: () => import('../components/unit/Edit'),
        meta: {id: 500, power: [8, 32]}
      },
      {
        name: '创意类型管理',
        icon: 'el-icon-takeaway-box',
        path: 'ideatype/list',
        component: () => import('../components/idea_type/List'),
        meta: {id: 600, power: [2]},
        aside: true
      },
      {
        path: 'ideatype/edit',
        component: () => import('../components/idea_type/Edit'),
        meta: {id: 600, power: [8, 32]}
      },
      {
        name: '创意管理',
        icon: 'el-icon-magic-stick',
        path: 'idea/list',
        component: () => import('../components/idea/List'),
        meta: {id: 700, power: [2]},
        aside: true
      },
      {
        path: 'idea/edit',
        component: () => import('../components/idea/Edit'),
        meta: {id: 700, power: [8, 32]}
      },
      {
        path: 'idea/detail',
        component: () => import('../components/idea/Detail'),
        meta: {id: 700, power: [8, 32]}
      },
      {
        father: '报表管理',
        fatherIcon: 'el-icon-pie-chart',
        name: '广告主报表',
        path: 'chart/adowner',
        component: () => import('../components/ad_owner/Chart'),
        meta: {id: 900, power: [2]},
        aside: true
      },
      {
        father: '报表管理',
        name: '投放单元报表',
        path: 'chart/unit',
        component: () => import('../components/unit/Chart'),
        meta: {id: 900, power: [4]},
        aside: true
      },
      {
        father: '报表管理',
        name: '创意报表',
        path: 'chart/idea',
        component: () => import('../components/idea/Chart'),
        meta: {id: 900, power: [8]},
        aside: true
      },
      {
        father: '报表管理',
        name: '报告总览',
        path: 'chart/report',
        component: () => import('../components/chart/report'),
        meta: {isIn: true, id: 900, power: [16]},
        aside: true
      },
      {
        father: '报表管理',
        name: '财务统计',
        path: 'chart/finance',
        component: () => import('../components/chart/finance'),
        meta: {isIn: true, id: 900, power: [32]},
        aside: true
      },
      {
        father: '报表管理',
        name: '广告统计',
        path: 'chart/advert',
        component: () => import('../components/chart/advert'),
        meta: {isIn: true, id: 900, power: [64]},
        aside: true
      },
      {
        father: '报表管理',
        name: '流量统计',
        path: 'chart/flow',
        component: () => import('../components/chart/flow'),
        meta: {isIn: true, id: 900, power: [128]},
        aside: true
      },
      {
        father: '报表管理',
        name: '包名报表',
        path: 'chart/pkg_rpt',
        component: () => import('../components/idea/PkgRpt'),
        meta: {id: 900, power: [256]},
        aside: true
      },
      {
        father: '报表管理',
        name: '代码位包名报表',
        path: 'chart/slot_pkg_rpt',
        component: () => import('../components/idea/SlotPkgRpt'),
        meta: {id: 900, power: [512]},
        aside: true
      },
      {
        father: '日志流管理',
        fatherIcon: 'el-icon-document-copy',
        name: '广告上报日志',
        path: 'logstream/report',
        component: () => import('../components/log_stream/Report'),
        meta: {id: 1000, power: [2]},
        aside: true
      },
      {
        father: '日志流管理',
        name: '广告请求日志',
        path: 'logstream/request',
        component: () => import('../components/log_stream/Request'),
        meta: {id: 1000, power: [4]},
        aside: true
      },
      {
        father: '日志流管理',
        name: '广告响应日志',
        path: 'logstream/response',
        component: () => import('../components/log_stream/Response'),
        meta: {id: 1000, power: [8, 32]},
        aside: true
      },
      {
        name: 'ADX管理',
        icon: 'el-icon-paperclip',
        path: 'adx/list',
        component: () => import('../components/adx/List'),
        meta: {id: 1200, power: [2]},
        aside: true
      },
      {
        path: 'adx/edit',
        component: () => import('../components/adx/Edit'),
        meta: {id: 1200, power: [8, 32]}
      },
      {
        name: '实时监控',
        icon: 'el-icon-data-line',
        path: 'monitor',
        component: () => import('../components/monitor/chart'),
        meta: {isIn: true, id: 1400, power: [2]},
        aside: true
      }
    ]
  },
  {
    path: '/404',
    component: () => import('../views/NotFound'),
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js